/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import { graphql, useStaticQuery } from 'gatsby'

// import FrontImage from '../images/strum-audio-whiteboarding-tool.png'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import React from 'react'

const defaultImage = 'https://strum.us/img/strum-audio-whiteboarding-tool.png'
function SEO({ description, lang, meta, title, image = defaultImage }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `,
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <div>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      >
        <title>{title}</title>
        <meta httpEquiv='content-language' content='en'></meta>
        <meta name='naver-site-verification' content='659b135f7d8b07d7db68152e74bbbff1199f68a7' />
        <meta property='og:type' content='website'/>
        <meta property='og:title' content='스트럼' />
        <meta property='og:title' content='스트럼코리아' />
        <meta property='og:title' content={title} />
        <meta property='description' content={metaDescription}/>
        <meta property='og:description' content={metaDescription}/>
        <meta property='description' content='화이트보드 미팅툴 스트럼'/>
        <meta property='og:image' itemProp='image' content={image}/>
        <meta property='og:image:secure' content={image} />
        <meta property='og:image:secure_url' content={image} />
        <meta property='og:url' content={'https://strum.us'}/>
        <meta property='og:type' content={'website'}/>
        <meta name='twitter:card' content={'summary'}/>
        <meta name='twitter:image' content={image}/>
        <meta name='twitter:creator' content={site.siteMetadata?.author || ''}/>
        <meta name='twitter:title' content={title}/>
        <meta name='twitter:description' content={metaDescription}/>
      </Helmet>
    </div>

  )
}

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  description: '',
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
